import { ReactNode } from 'react';

const emptyCommand = (): ReactNode => <></>;
const invalidCommand = ({ command }: { command: string }): ReactNode => <>{command}: Command not found</>;
const unauthCommand = (): ReactNode => <>Operation denied! Your role is incapable of executing this command.</>;
const ExceptionTemplate = (): ReactNode => <>Something went wrong. Please try again!</>;
const ExceptionTemplateOOM = (): ReactNode => <>Something went wrong. Your solution may be consuming too much memory and CPU.</>;

export { emptyCommand, invalidCommand, unauthCommand, ExceptionTemplate, ExceptionTemplateOOM };
